<p class="d-flex detail" [ngClass]="class">
  <b>{{ label }}</b>
  <span class="ms-auto"> {{ value || '-' }}</span>
</p>
